'use client';
import React, { useState } from 'react';
import {
  motion,
  useTransform,
  AnimatePresence,
  useMotionValue,
  useSpring,
} from 'framer-motion';
import Image from 'next/image';

export const AnimatedTooltip = ({ items }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const springConfig = { stiffness: 100, damping: 5 };
  const x = useMotionValue(0);
  const rotate = useSpring(
    useTransform(x, [-100, 100], [-45, 45]),
    springConfig
  );
  const translateX = useSpring(
    useTransform(x, [-100, 100], [-50, 50]),
    springConfig
  );

  const handleMouseMove = event => {
    const halfWidth = event.target.offsetWidth / 2;
    x.set(event.nativeEvent.offsetX - halfWidth); // Set x value for mouse move
  };

  return (
    <>
      {items.map((item, idx) => (
        <div
          className='relative group'
          key={item.id}
          onMouseEnter={() => setHoveredIndex(item.id)}
          onMouseLeave={() => setHoveredIndex(null)}
        >
          <AnimatePresence>
            {hoveredIndex === item.id && (
              <motion.div
                initial={{ opacity: 0, y: 20, scale: 0.6 }}
                animate={{
                  opacity: 1,
                  y: 0,
                  scale: 1,
                  transition: {
                    type: 'spring',
                    stiffness: 260,
                    damping: 10,
                  },
                }}
                exit={{ opacity: 0, y: 20, scale: 0.6 }}
                style={{
                  translateX: translateX,
                  rotate: rotate,
                  whiteSpace: 'nowrap',
                }}
                className='absolute -top-16 -left-1/2 translate-x-1/2 flex text-xs flex-col items-center justify-center rounded-md bg-black z-50 shadow-xl px-4 py-2'
              >
                <div className='absolute inset-x-10 z-30 w-[20%] -bottom-px bg-gradient-to-r from-transparent via-emerald-500 to-transparent h-px' />
                <div className='absolute left-10 w-[40%] z-30 -bottom-px bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px' />
                <div className='font-bold text-white relative z-30 text-base'>
                  {item.name}
                </div>
                <div className='text-white text-xs'>{item.designation}</div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Image Element */}
          <div className='w-16 md:w-20 h-16 md:h-20 p-2 bg-white rounded-full flex justify-center items-center hover:shadow-lg hover:shadow-slate-400 cursor-pointer hover:scale-105 transition-transform duration-200'>
            {item.skill?.image ? (
              <Image
                src={item.skill.image}
                alt={item.name}
                width={80}
                height={80}
                className='rounded-full object-contain'
                onMouseMove={handleMouseMove}
              />
            ) : (
              <div className='text-gray-500'>No Image</div>
            )}
          </div>
        </div>
      ))}
    </>
  );
};
